// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Qi06f0xH8kfy2oJLHw-_h","infoBox":"Tc3YrmhmIu2p47Ex2JmjV","content":"f9t5Dmz_y2IjCCmCQ02p4","closeButton":"_1PSlSabbWlr54SzB3HJvRU"};